import { Panel } from 'containers/admin/pages';

import { ROUTE_ADMIN_PREFIX as ROUTE_PREFIX } from 'utils/routes';

const adminRoutes = [
  {
    name: 'Admin',
    path: '/panel',
    component: Panel,
    nav: true,
  },
];

const Routes = adminRoutes.map((route) => {
  return {
    ...route,
    path: `${ROUTE_PREFIX}${route.path}`,
    public: false,
    confirmedUser: true,
    admin: true,
  };
});

export default Routes;
